import { UploadCard as CXUploadCard } from '@sanlamcx/react-ui-next-upload-card';

export const UploadCard = CXUploadCard;
